module.exports = __webpack_public_path__ + "media/logo.d7653237.png";